var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { HTTP_STATUS_CODES, NodeAuthMiddlewareErrorCodes, RefreshFailureReasons, } from './clientOAuthInterceptors.types';
export function configureAxiosInstanceForOAuth(axiosInstance, options) {
    var _a, _b;
    if (options === void 0) { options = {}; }
    var safeOptions = {
        dashboardBaseUrl: (_a = options.dashboardBaseUrl) !== null && _a !== void 0 ? _a : location.origin,
        refreshTimeoutMs: (_b = options.refreshTimeoutMs) !== null && _b !== void 0 ? _b : 10000,
    };
    var dashboardBackend = axios.create({
        baseURL: safeOptions.dashboardBaseUrl,
    });
    function interceptErrorResponse(errorResponse) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var shouldTryToRefreshAccessToken, _c, refreshSuccess, refreshError, flaggedConfig, retryError_1;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        shouldTryToRefreshAccessToken = isNodeAuthMiddlewareOktaAuthChallenge(errorResponse) &&
                            // must have config to be able to retry the request after refresh
                            errorResponse.config &&
                            // must not already be a retry request, to prevent infinite refresh loops
                            !errorResponse.config
                                .isRetryAfterOAuthRefresh;
                        if (!shouldTryToRefreshAccessToken) {
                            throw errorResponse;
                        }
                        return [4 /*yield*/, doOktaTokenRefresh()];
                    case 1:
                        _c = _d.sent(), refreshSuccess = _c.refreshSuccess, refreshError = _c.refreshError;
                        if (!refreshSuccess) return [3 /*break*/, 6];
                        flaggedConfig = __assign(__assign({}, errorResponse.config), { isRetryAfterOAuthRefresh: true });
                        _d.label = 2;
                    case 2:
                        _d.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, axiosInstance.request(flaggedConfig)];
                    case 3: return [2 /*return*/, _d.sent()];
                    case 4:
                        retryError_1 = _d.sent();
                        console.error('Error retrying pending requests:', retryError_1);
                        // when Okta token refreshed but pending requests still receive 401, do logout;
                        // all other errors, let them through
                        if (axios.isAxiosError(retryError_1) &&
                            ((_a = retryError_1.response) === null || _a === void 0 ? void 0 : _a.status) ===
                                HTTP_STATUS_CODES.UNAUTHORIZED) {
                            triggerLogoutFlow(RefreshFailureReasons.INVALID_TOKEN_AFTER_REFRESH);
                        }
                        throw retryError_1;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        // if Okta token's refresh endpoint returns 401, do page reload;
                        // auth-middleware in Dashboard always fires first when page loads, so it will try to refresh token by itself;
                        if (axios.isAxiosError(refreshError) &&
                            ((_b = refreshError.response) === null || _b === void 0 ? void 0 : _b.status) === HTTP_STATUS_CODES.UNAUTHORIZED) {
                            triggerPageReload();
                        }
                        else {
                            // if Okta token's refresh endpoint returns errors !== 401, do logout
                            triggerLogoutFlow(RefreshFailureReasons.TOKEN_REFRESH_FAILED);
                        }
                        throw errorResponse;
                    case 7: return [2 /*return*/];
                }
            });
        });
    }
    function doOktaTokenRefresh() {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var global, refreshError_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        global = getGlobalRefreshHolder();
                        (_a = global.__pendingOktaTokenRefresh) !== null && _a !== void 0 ? _a : (global.__pendingOktaTokenRefresh = dashboardBackend.post('/spoton_auth_middleware_refresh_auth', {}, { timeout: safeOptions.refreshTimeoutMs }));
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, global.__pendingOktaTokenRefresh];
                    case 2:
                        _b.sent();
                        return [2 /*return*/, { refreshSuccess: true, refreshError: null }];
                    case 3:
                        refreshError_1 = _b.sent();
                        console.error('Error refreshing OAuth token:', refreshError_1);
                        return [2 /*return*/, { refreshSuccess: false, refreshError: refreshError_1 }];
                    case 4:
                        delete global.__pendingOktaTokenRefresh;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function triggerPageReload() {
        // when BFF throws 401 and we can't refresh Okta token afterward, we can do page refresh;
        // with this approach Dashboard's auth-middleware will detect that auth cookies are not right and will try
        // to refresh the Okta token on its own;
        // if token refreshed successfully, user stays on the same location;
        // if refresh failed, user redirected to a proper login page;
        location.reload();
    }
    function triggerLogoutFlow(reason) {
        console.error('Unable to refresh user authentication, logging out: ', reason);
        var url = new URL('/logout', safeOptions.dashboardBaseUrl);
        location.assign(url.toString());
    }
    function interceptSuccessResponse(response) {
        return response;
    }
    axiosInstance.interceptors.response.use(interceptSuccessResponse, interceptErrorResponse);
}
function isNodeAuthMiddlewareOktaAuthChallenge(errorResponse) {
    var _a, _b, _c;
    return (axios.isAxiosError(errorResponse) &&
        ((_a = errorResponse.response) === null || _a === void 0 ? void 0 : _a.status) === HTTP_STATUS_CODES.UNAUTHORIZED &&
        ((_c = (_b = errorResponse.response.data) === null || _b === void 0 ? void 0 : _b.errors) === null || _c === void 0 ? void 0 : _c.internalErrorCode) ===
            NodeAuthMiddlewareErrorCodes.OKTA_VALIDATION_NEEDED);
}
function getGlobalRefreshHolder() {
    return (typeof globalThis !== 'undefined' ? globalThis : window);
}
